import script from "./message-container.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-container.vue?vue&type=script&setup=true&lang=ts"

import "./message-container.vue?vue&type=style&index=0&id=d90f4db4&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.31_vue@3.5.31_typescript@5.6.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d90f4db4"]])

export default __exports__